import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/atendimento-triagem`

    return {
        index(queryParms = {}) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        create: (id) => {
            return repository.get(`${baseUrl}/${id}/create`)
        },
        store: (params) => {
            return repository.post(`${baseUrl}`, params)
        },
        storeFaaAssinada: (id, params) => {
            return repository.post(`${baseUrl}/${id}/store-faa-assinada`, params)
        },
    }
}